/* Henne bike builder engine (sections/henne-bike-builder.liquid). The platform profile (zones, photos, part
   types, fitment words) comes from assets/henne-bb-<profile>.js. Bikes come from the Harley finder index
   (assets/henne-ymm-index.json); parts, prices and stock load per bike from /collections/<bike>?view=henne-bb.
   A part shows when it is in the bike's year/model collection (or, with no year/model collection of that model,
   in a range collection covering the bike) AND at least one of its variants is made for this bike: option values
   like "Touring 14-23", "CVO Road Glide 23.5-up" or "Touring 2017-up (Not for CVO)" are read for model, year,
   CVO, ST and engine family. */
(function () {
  "use strict";
  var root = document.querySelector("[data-hbb]");
  if (!root) return;
  var PROFILE_ID = root.getAttribute("data-profile") || "touring";
  var PROF = (window.HenneBikeBuilderProfiles || {})[PROFILE_ID];
  var $picker = root.querySelector("[data-hfb-picker]");
  if (!PROF) { $picker.innerHTML = '<p class="hfb-empty">This builder is not set up yet.</p>'; return; }

  var STORE_KEY = "henne_bike_builder_" + PROFILE_ID + "_v1";
  var GARAGE_KEY = "henne_ymm_bike"; // written by the Harley finder: {year, family, model, handle}
  var ZONES = PROF.zones, ZONE = {}, SINGLE = {};
  ZONES.forEach(function (z) { ZONE[z.id] = z; z.slots.forEach(function (s) { SINGLE[s[0]] = !!s[2]; }); });
  var RULES = PROF.rules || [];

  /* ---------- helpers ---------- */
  function money(n) { return "$" + Number(n).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  var BRAND = { "Rick's Motorcycles": "Rick's", "Henne Co": "Henne", "Arnott Air Ride": "Arnott", "JRi Shocks": "JRi" };
  function brand(v) { return BRAND[v] || v; }
  var PFX = ["Wings Custom ", "Killer Custom ", "Rick's ", "BTC ", "Raceworks ", "Daytona27 ", "Arnott ", "JRi "];
  function shortTitle(t) { for (var i = 0; i < PFX.length; i++) if (t.indexOf(PFX[i]) === 0) return t.slice(PFX[i].length); return t; }
  function readJSON(key) { try { return JSON.parse(window.localStorage.getItem(key) || "null"); } catch (e) { return null; } }
  function writeJSON(key, val) { try { window.localStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* storage blocked */ } }
  function list(s) { return String(s || "").split(",").map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean); }
  function parseJSON(sel, fallback) { try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { return fallback; } }
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  /* ---------- settings ---------- */
  var PHOTOS = parseJSON("[data-hbb-photos]", {});
  var RANGES = parseJSON("[data-hbb-ranges]", []).map(function (r) {
    var m = r.t.match(/^(\d{4})-(\d{4})\b/);
    var slug = r.h.split("harley-davidson-").pop();
    return m ? { h: r.h, from: +m[1], to: +m[2], key: "harley-davidson-" + slug + "-" } : null;
  }).filter(Boolean);
  var FAMILY = root.getAttribute("data-family") || "Touring";
  var INCLUDE = list(root.getAttribute("data-include"));
  var EXCLUDE = list(root.getAttribute("data-exclude"));
  var Y_FROM = parseInt(root.getAttribute("data-year-from"), 10) || 0;
  var Y_TO = parseInt(root.getAttribute("data-year-to"), 10) || 9999;
  var DEFAULT_BIKE = root.getAttribute("data-default") || "";

  /* ---------- bikes ---------- */
  var BIKES = [];
  function makeBike(y, m, h) {
    return { h: h, y: y, m: m, key: PROF.photoKey(m), group: PROF.group ? PROF.group(m) : "", cvo: /\bCVO\b/i.test(m), st: /\bST\b/.test(m), m8: y >= 2017 };
  }
  function loadBikes() {
    return fetch(root.getAttribute("data-index"), { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (ix) {
      var out = [];
      Object.keys(ix.y || {}).forEach(function (yr) {
        var y = +yr;
        if (y < Y_FROM || y > Y_TO) return;
        (ix.y[yr][FAMILY] || []).forEach(function (e) {
          var name = e.m.toLowerCase();
          if (INCLUDE.length && !INCLUDE.some(function (w) { return name.indexOf(w) >= 0; })) return;
          if (EXCLUDE.some(function (w) { return name.indexOf(w) >= 0; })) return;
          out.push(makeBike(y, e.m, e.h));
        });
      });
      BIKES = out.sort(function (a, b) { return a.y - b.y || a.group.localeCompare(b.group) || a.m.localeCompare(b.m); });
    });
  }
  function bikeLabel(b) { b = b || bike(); return b.y + " " + b.m; }

  /* ---------- variant fitment ---------- */
  var FIT_OPT_RE = /year|model|famil|version|frame|bike|variant|title|fit|type|engine/i;
  var NOT_CVO_RE = /(not for|except|excl\.?|non-?)\s*cvo/i;
  function yy(x) { return x.length === 4 ? +x : (+x <= 40 ? 2000 + +x : 1900 + +x); }
  function yearsOf(t) {
    var out = [], m, re1 = /\b(\d{4}|\d\d)(?:\.\d)?\s*-\s*(\d{4}|\d\d|up)\b/gi, re2 = /\b(\d{4})\s*[+-](?!\s*\d)/g;
    while ((m = re1.exec(t))) out.push([yy(m[1]), /up/i.test(m[2]) ? 9999 : yy(m[2])]);
    while ((m = re2.exec(t))) out.push([+m[1], 9999]);
    return out;
  }
  var fitCache = {}, scoreCache = {};
  function fitOf(b) { return fitCache[b.h] || (fitCache[b.h] = PROF.fit(b)); }
  // -1 = not for this bike, 0 = says nothing about fitment, >= 1 = made for this bike (higher = more specific)
  function valueScore(name, val, b) {
    var key = b.h + "|" + name + "|" + val;
    if (key in scoreCache) return scoreCache[key];
    var F = fitOf(b), res = 0, raw = String(val);
    if (NOT_CVO_RE.test(raw) && b.cvo) res = -1;
    else {
      var s = raw.replace(/\((?:except|not for)[^)]*\)/gi, "").replace(NOT_CVO_RE, "").replace(/\bno \w+/gi, "");
      if (FIT_OPT_RE.test(name) || F.pos.test(s) || F.neg.test(s) || /twin ?cam|milwaukee[- ]?eight|\bm8\b/i.test(s)) {
        var segs = s.split(/\s*;\s*|\s+\/\s+|\s+&\s+|\s+and\s+/i).map(function (t) {
          var f = F.pos.test(t), o = F.neg.test(t);
          return {
            t: t,
            fam: f && o ? (F.named.test(t) ? "ok" : "other") : f ? "ok" : o ? "other" : null,
            yr: yearsOf(t),
            cvo: /\bcvo\b/i.test(t), st: /\bST\b/.test(t),
            tc: /twin ?cam/i.test(t), m8: /milwaukee[- ]?eight|\bm8\b/i.test(t),
            g1: /gen ?1/i.test(t), g2: /gen ?2/i.test(t)
          };
        });
        var i;
        // a bare part after "/" belongs to the model before it; years after the last model name apply to the names before it
        for (i = 1; i < segs.length; i++) if (!segs[i].fam && segs[i - 1].fam) { segs[i].fam = segs[i - 1].fam; if (!segs[i].yr.length) segs[i].yr = segs[i - 1].yr; }
        for (i = segs.length - 2; i >= 0; i--) if (segs[i].fam && !segs[i].yr.length && segs[i + 1].yr.length) segs[i].yr = segs[i + 1].yr;
        if (segs.some(function (g) { return g.fam || g.yr.length || g.cvo || g.tc || g.m8; })) {
          var y = b.y;
          var hits = segs.filter(function (g) {
            if (g.fam === "other") return false;
            if (g.yr.length && !g.yr.some(function (r) { return y >= r[0] && y <= r[1]; })) return false;
            if (g.cvo && !b.cvo) return false;
            if (g.st && !b.st) return false;
            if (g.tc && b.m8) return false;
            if (g.m8 && !b.m8) return false;
            if (g.g1 && y >= 2024) return false;
            if (g.g2 && y < 2024) return false;
            return true;
          });
          if (!hits.length) res = -1;
          else res = Math.max.apply(null, hits.map(function (g) {
            var start = 0;
            g.yr.forEach(function (r) { if (y >= r[0] && y <= r[1]) start = Math.max(start, r[0]); });
            return 1 + (F.named.test(g.t) ? 0.5 : 0) + (g.cvo && b.cvo ? 0.3 : 0) + (g.st && b.st ? 0.3 : 0) + start / 1e5;
          }));
        }
      }
    }
    scoreCache[key] = res;
    return res;
  }
  function variantScore(p, v, b) {
    b = b || bike();
    var n = 0;
    for (var k = 0; k < p.o.length; k++) { var s = valueScore(p.o[k].n, v.o[k], b); if (s < 0) return -1; n += s; }
    return n;
  }
  function okVariants(p, b) { b = b || bike(); return p.vs.filter(function (v) { return variantScore(p, v, b) >= 0; }); }

  /* ---------- data ---------- */
  var PRODUCTS = {};   // id -> product, from every bike loaded so far
  var BIKE_SETS = {};  // bike handle -> { ids }
  var RANGE_DATA = {}; // range handle -> promise of raw products
  var loading = {};
  function normalize(raw) {
    var c = PROF.classify(raw.y, raw.t);
    if (!c) return null;
    var isDefault = raw.o.length === 1 && raw.o[0][1].length === 1 && raw.o[0][1][0] === "Default Title";
    return {
      i: raw.id, t: raw.t, h: raw.h, v: raw.v, z: c[0], s: c[1], img: raw.img, sp: raw.sp || null,
      o: isDefault ? [] : raw.o.map(function (o) { return { n: o[0], vals: o[1] }; }),
      vs: raw.vs.map(function (v) {
        return { id: v[0], p: v[1] / 100, a: v[3], o: isDefault ? [] : v[2].map(function (ix, k) { return (raw.o[k] && raw.o[k][1][ix]) || ""; }) };
      })
    };
  }
  function fetchCollection(handle) {
    var out = [];
    function page(n) {
      return fetch(shopRoot + "collections/" + encodeURIComponent(handle) + "?view=henne-bb&page=" + n, { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.text(); })
        .then(function (txt) {
          var j = JSON.parse(txt);
          out = out.concat(j.products || []);
          return j.pages > n && n < 8 ? page(n + 1) : out;
        });
    }
    return page(1);
  }
  function rangeProducts(r) { return RANGE_DATA[r.h] || (RANGE_DATA[r.h] = fetchCollection(r.h).catch(function () { return []; })); }
  // range collections are tag-based and sometimes hold older parts ("... - Touring 2000-2008"): the title's own years must cover the bike
  function titleFitsYear(t, y) {
    var m = t.match(/(?:touring|glide|softail|fat boy|cvo|dyna|sportster)[^\/;]*?\b(\d{4}|\d\d)(?:\.\d)?\s*-\s*(\d{4}|\d\d|up)\b/i);
    if (!m) return true;
    return y >= yy(m[1]) && y <= (/up/i.test(m[2]) ? 9999 : yy(m[2]));
  }
  function loadBike(b) {
    if (BIKE_SETS[b.h]) return Promise.resolve(BIKE_SETS[b.h]);
    if (loading[b.h]) return loading[b.h];
    var ranges = RANGES.filter(function (r) { return b.y >= r.from && b.y <= r.to && b.h.indexOf(r.key) >= 0; });
    loading[b.h] = Promise.all([fetchCollection(b.h)].concat(ranges.map(rangeProducts))).then(function (res) {
      var ids = {};
      res.forEach(function (rows, n) {
        rows.forEach(function (raw) {
          if (n > 0 && (raw.yc || !titleFitsYear(raw.t, b.y))) return; // range part with its own year/model pages (those decide) or for other years
          var p = PRODUCTS[raw.id] || normalize(raw);
          if (p) { PRODUCTS[p.i] = p; ids[p.i] = 1; }
        });
      });
      BIKE_SETS[b.h] = { ids: ids };
      delete loading[b.h];
      return BIKE_SETS[b.h];
    }, function (err) { delete loading[b.h]; throw err; });
    return loading[b.h];
  }

  /* ---------- state ---------- */
  var state = { bike: null, sel: {}, zone: ZONES[0].id, q: "", flash: null, copyText: null, msg: null, busy: false, ready: false };
  function bike() { for (var i = 0; i < BIKES.length; i++) if (BIKES[i].h === state.bike) return BIKES[i]; return BIKES[0]; }
  function bikeSet() { return BIKE_SETS[bike().h]; }
  function all() { var s = bikeSet(); return s ? Object.keys(s.ids).map(function (id) { return PRODUCTS[id]; }) : []; }
  function fits(p) { var s = bikeSet(); return !!(s && s.ids[p.i] && okVariants(p).length); }
  function selected() { return Object.keys(state.sel).map(function (id) { return PRODUCTS[id]; }).filter(Boolean); }
  function variantOf(p) { var id = state.sel[p.i]; for (var i = 0; i < p.vs.length; i++) if (p.vs[i].id === id) return p.vs[i]; return p.vs[0]; }
  function priceRange(p) {
    var vs = okVariants(p); if (!vs.length) vs = p.vs;
    var ps = vs.map(function (v) { return v.p; });
    return [Math.min.apply(null, ps), Math.max.apply(null, ps)];
  }
  function defaultVariant(p) {
    var vs = okVariants(p); if (!vs.length) vs = p.vs;
    var avail = vs.filter(function (v) { return v.a; }); if (avail.length) vs = avail;
    var best = vs[0], bs = -Infinity;
    vs.forEach(function (v) { var s = variantScore(p, v); if (s > bs) { bs = s; best = v; } });
    return best;
  }
  function sameOpts(v, cur, skip) { var n = 0; for (var k = 0; k < v.o.length; k++) if (k !== skip && v.o[k] === cur.o[k]) n++; return n + (v.a ? 0.5 : 0); }
  function add(p, vid) {
    if (SINGLE[p.s]) selected().forEach(function (q) { if (q.s === p.s && q.i !== p.i) delete state.sel[q.i]; });
    state.sel[p.i] = vid || defaultVariant(p).id;
  }
  function remove(p) { delete state.sel[p.i]; }
  function unmetNeeds(p) {
    var others = selected().filter(function (q) { return q.i !== p.i; });
    var out = [];
    RULES.forEach(function (r, k) { if (r.re.test(p.t) && !others.some(function (q) { return r.need.test(q.t); })) out.push({ r: r, k: k }); });
    return out;
  }
  function save() { writeJSON(STORE_KEY, { bike: state.bike, sel: state.sel, zone: state.zone }); }

  /* ---------- elements ---------- */
  var $year = root.querySelector("[data-hfb-year]"), $model = root.querySelector("[data-hfb-model]");
  var $stage = root.querySelector("[data-hfb-stage]"), $photo = root.querySelector("[data-hbb-photo]"), $caption = root.querySelector("[data-hbb-caption]");
  var $zones = root.querySelector("[data-hfb-zones]"), $sheet = root.querySelector("[data-hfb-sheet]");
  var $dock = root.querySelector("[data-hfb-dock]"), $toast = root.querySelector("[data-hfb-toast]"), $count = root.querySelector("[data-hfb-count]");

  function fillBikeSelects() {
    var years = [];
    BIKES.forEach(function (b) { if (years.indexOf(b.y) < 0) years.push(b.y); });
    $year.innerHTML = years.map(function (y) { return '<option value="' + y + '">' + y + "</option>"; }).join("");
    $year.value = String(bike().y);
    fillModels();
  }
  function fillModels() {
    var y = +$year.value;
    var ms = BIKES.filter(function (b) { return b.y === y; });
    var groups = [];
    ms.forEach(function (b) { if (groups.indexOf(b.group) < 0) groups.push(b.group); });
    $model.innerHTML = groups.map(function (g) {
      var opts = ms.filter(function (b) { return b.group === g; }).map(function (b) { return '<option value="' + esc(b.h) + '">' + esc(b.m) + "</option>"; }).join("");
      return g && groups.length > 1 ? '<optgroup label="' + esc(g) + '">' + opts + "</optgroup>" : opts;
    }).join("");
    $model.value = ms.some(function (b) { return b.h === state.bike; }) ? state.bike : ms[0].h;
  }
  function setBike(h) {
    state.bike = h;
    state.ready = false;
    render();
    loadBike(bike()).then(function () {
      if (state.bike !== h) return;
      // parts already in the build switch to the variant made for this bike, keeping the other options
      selected().forEach(function (p) {
        var cur = variantOf(p);
        if (variantScore(p, cur) >= 0) return;
        var better = okVariants(p).sort(function (a, b) { return sameOpts(b, cur, -1) - sameOpts(a, cur, -1); })[0];
        if (better) state.sel[p.i] = better.id;
      });
      state.ready = true;
      render();
    }, function () {
      state.ready = true;
      state.msg = "We couldn't load the parts for this bike. Please refresh the page.";
      render();
    });
  }
  $year.addEventListener("change", function () { fillModels(); setBike($model.value); });
  $model.addEventListener("change", function () { setBike($model.value); });

  /* ---------- render ---------- */
  function zoneSel(z) { return selected().filter(function (p) { return p.z === z.id; }); }
  function zoneCount(z) { return all().filter(function (p) { return p.z === z.id && fits(p); }).length; }
  function renderPhoto() {
    var key = bike().key;
    if (PHOTOS[key] && $photo.getAttribute("src") !== PHOTOS[key]) {
      $photo.src = PHOTOS[key];
      $photo.alt = (PROF.alts && PROF.alts[key]) || "";
    }
    $caption.textContent = (PROF.captions && PROF.captions[key]) || "";
  }
  function renderStage() {
    Array.prototype.forEach.call($stage.querySelectorAll(".hfb-pin"), function (n) { n.remove(); });
    var key = bike().key;
    ZONES.forEach(function (z) {
      var pos = z.pos[key];
      if (!pos) return;
      var sel = zoneSel(z), n = state.ready ? zoneCount(z) : 1;
      if (!n && !sel.length) return;
      var b = document.createElement("button");
      b.type = "button";
      b.className = "hfb-pin" + (sel.length ? " is-set" : "") + (state.zone === z.id ? " is-active" : "");
      b.style.left = pos[0] + "%"; b.style.top = pos[1] + "%";
      b.setAttribute("data-action", "zone"); b.setAttribute("data-z", z.id);
      b.setAttribute("aria-label", z.name + ": " + (sel.length ? sel.length + " selected" : n + " parts"));
      b.innerHTML = (sel.length && sel[0].img ? '<img src="' + esc(sel[0].img) + '" alt="">' : '<span class="hfb-plus"></span>')
        + (sel.length > 1 ? '<span class="hfb-pin__n">' + sel.length + "</span>" : "")
        + '<span class="hfb-pin__label">' + esc(z.name) + "</span>";
      $stage.appendChild(b);
    });
  }
  function renderZones() {
    $zones.innerHTML = ZONES.map(function (z) {
      var n = state.ready ? zoneCount(z) : 1, s = zoneSel(z).length;
      return '<button type="button" class="hfb-chip' + (n ? "" : " is-empty") + '" data-action="zone" data-z="' + z.id + '" aria-current="' + (state.zone === z.id) + '">' + esc(z.name) + (s ? '<span class="hfb-chip__n">' + s + "</span>" : "") + "</button>";
    }).join("");
  }
  function productUrl(p, v) { return shopRoot + "products/" + p.h + (v ? "?variant=" + v.id : ""); }
  function cardHTML(p) {
    var on = state.sel[p.i] != null;
    var pr = priceRange(p);
    var v = on ? variantOf(p) : null;
    var price = on ? money(v.p) : (pr[0] === pr[1] ? money(pr[0]) : "<small>from</small> " + money(pr[0]));
    var anyAvail = okVariants(p).some(function (x) { return x.a; });
    var detail = "";
    if (on) {
      var oks = okVariants(p);
      var opts = p.o.map(function (o, k) {
        var vals = o.vals.filter(function (val) { return oks.some(function (x) { return x.o[k] === val; }); });
        return '<label class="hfb-opt"><span>' + esc(o.n) + '</span><select data-action="opt" data-p="' + p.i + '" data-k="' + k + '">'
          + vals.map(function (val) { return "<option" + (v.o[k] === val ? " selected" : "") + ">" + esc(val) + "</option>"; }).join("") + "</select></label>";
      }).join("");
      var notes = (PROF.notes ? PROF.notes(p) : []).map(function (t) { return '<div class="hfb-note">' + esc(t) + "</div>"; }).join("");
      var needs = unmetNeeds(p).map(function (n) { return '<div class="hfb-note hfb-note--need">' + esc(n.r.text) + '<button type="button" data-action="need" data-k="' + n.k + '">Show it</button></div>'; }).join("");
      var sold = v.a ? "" : '<div class="hfb-note hfb-note--need">This option is sold out right now.</div>';
      detail = '<div class="hfb-card__detail">' + (opts ? '<div class="hfb-opts">' + opts + "</div>" : "") + sold + needs + notes
        + '<div class="hfb-links"><a href="' + esc(productUrl(p, v)) + '" target="_blank" rel="noopener">View product ↗</a><button type="button" data-action="remove" data-p="' + p.i + '">Remove</button></div></div>';
    }
    return '<div class="hfb-card' + (on ? " is-sel" : "") + (state.flash === p.i ? " is-flash" : "") + '" id="hbb-card-' + p.i + '">'
      + '<button type="button" class="hfb-card__main" data-action="toggle" data-p="' + p.i + '" aria-pressed="' + on + '">'
      + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="64" height="64">' : "<span></span>")
      + '<span class="hfb-card__txt"><span class="hfb-card__vendor">' + esc(brand(p.v)) + '</span><span class="hfb-card__title">' + esc(shortTitle(p.t)) + "</span></span>"
      + '<span class="hfb-card__side"><span class="hfb-card__price num">' + price + "</span>"
      + (anyAvail || on ? '<span class="hfb-card__act">' + (on ? "In build" : "Add") + "</span>" : '<span class="hfb-card__soldout">Sold out</span>')
      + "</span></button>" + detail + "</div>";
  }
  function renderPicker() {
    var z = ZONE[state.zone];
    if (!state.ready) { $picker.innerHTML = '<h2 class="hfb-pk__title">' + esc(z.name) + '</h2><p class="hfb-empty">Loading parts for your ' + esc(bikeLabel()) + "…</p>"; return; }
    var q = state.q.trim().toLowerCase();
    var inZone = all().filter(function (p) { return p.z === z.id && fits(p); });
    var shown = q ? inZone.filter(function (p) { return (p.t + " " + p.v).toLowerCase().indexOf(q) >= 0; }) : inZone;
    var body = "";
    z.slots.forEach(function (sl) {
      var items = shown.filter(function (p) { return p.s === sl[0]; }).sort(function (a, b) { return priceRange(a)[0] - priceRange(b)[0]; });
      if (!items.length) return;
      body += '<div class="hfb-slot"><h3 class="hfb-slot__h">' + esc(sl[1]) + "<small>" + (sl[2] ? "choose one" : "choose any") + " · " + items.length + '</small></h3><div class="hfb-cards">' + items.map(cardHTML).join("") + "</div></div>";
    });
    if (!body) body = '<p class="hfb-empty">' + (inZone.length ? "No parts match this search." : "We don't have parts for this area that fit your bike yet.") + "</p>";
    var focused = document.activeElement && document.activeElement.hasAttribute && document.activeElement.hasAttribute("data-hfb-q");
    var caret = focused ? document.activeElement.selectionStart : null;
    $picker.innerHTML = '<h2 class="hfb-pk__title">' + esc(z.name) + "</h2>"
      + '<p class="hfb-pk__fit"><b>' + inZone.length + " " + (inZone.length === 1 ? "part fits" : "parts fit") + "</b> your " + esc(bikeLabel()) + "</p>"
      + (inZone.length > 6 ? '<input class="hfb-search" data-hfb-q type="search" placeholder="Search ' + esc(z.name.toLowerCase()) + '" value="' + esc(state.q) + '" aria-label="Search parts in this area">' : "")
      + body;
    if (focused) { var i = $picker.querySelector("[data-hfb-q]"); if (i) { i.focus(); i.setSelectionRange(caret, caret); } }
  }
  function buildRows() {
    var rows = [];
    ZONES.forEach(function (z) { zoneSel(z).forEach(function (p) { rows.push({ z: z, p: p, v: variantOf(p), ok: !state.ready || fits(p) }); }); });
    return rows;
  }
  function variantText(p, v) { return p.o.length ? v.o.join(" / ") : ""; }
  function renderSheet() {
    var rows = buildRows();
    var good = rows.filter(function (r) { return r.ok; }), bad = rows.filter(function (r) { return !r.ok; });
    var total = good.reduce(function (s, r) { return s + r.v.p; }, 0);
    var needs = [];
    rows.forEach(function (r) { unmetNeeds(r.p).forEach(function (n) { needs.push({ r: n.r, k: n.k, p: r.p }); }); });
    var h = '<div class="hfb-sheet__head"><div><h2 class="hfb-sheet__title">Your build</h2><p class="hfb-sheet__sub">' + esc(bikeLabel()) + " · " + good.length + " " + (good.length === 1 ? "part" : "parts") + "</p></div>"
      + '<div class="hfb-acts"><button class="hfb-btn" type="button" data-action="copy"' + (good.length ? "" : " disabled") + ">Copy parts list</button>"
      + '<button class="hfb-btn hfb-btn--gold" type="button" data-action="cart"' + (good.length && !state.busy ? "" : " disabled") + ">" + (state.busy ? "Adding…" : "Add build to cart") + "</button></div></div>";
    if (state.msg) h += '<div class="hfb-note hfb-note--need hfb-msg">' + esc(state.msg) + "</div>";
    if (!rows.length) {
      h += '<p class="hfb-empty">Your bike is stock right now. Tap a point on the photo to add the first part.</p>';
    } else {
      h += '<div class="hfb-rows">' + rows.map(function (r) {
        return '<div class="hfb-row' + (r.ok ? "" : " is-bad") + '"><span class="hfb-row__zone">' + esc(r.z.name) + "</span>"
          + (r.p.img ? '<img src="' + esc(r.p.img) + '" alt="" loading="lazy">' : "<span></span>")
          + '<span class="hfb-row__name"><a href="' + esc(productUrl(r.p, r.v)) + '" target="_blank" rel="noopener">' + esc(r.p.t) + "</a>"
          + (variantText(r.p, r.v) ? "<small>" + esc(variantText(r.p, r.v)) + "</small>" : "")
          + (r.ok ? "" : '<span class="hfb-tag">Doesn\'t fit your ' + esc(bikeLabel()) + "</span>")
          + (r.ok && !r.v.a ? '<span class="hfb-tag">Sold out</span>' : "") + "</span>"
          + '<span class="hfb-row__price num">' + money(r.v.p) + "</span>"
          + '<button type="button" class="hfb-row__x" data-action="remove" data-p="' + r.p.i + '" aria-label="Remove ' + esc(r.p.t) + '">×</button></div>';
      }).join("") + "</div>";
      if (needs.length) h += '<div style="display:grid;gap:6px;margin-top:12px">' + needs.map(function (n) { return '<div class="hfb-note hfb-note--need">' + esc(shortTitle(n.p.t)) + ": " + esc(n.r.text) + '<button type="button" data-action="need" data-k="' + n.k + '">Show it</button></div>'; }).join("") + "</div>";
      if (bad.length) h += '<p style="margin-top:12px"><button class="hfb-btn" type="button" data-action="dropbad">Remove ' + bad.length + " " + (bad.length === 1 ? "part that doesn't" : "parts that don't") + " fit</button></p>";
      h += '<div class="hfb-total"><span>Parts total</span><b class="num">' + money(total) + "</b></div>"
        + '<p class="hfb-fine">Shipping, tax and installation are not included. Many parts are made to order; lead time and deposit options are on each product page.</p>';
    }
    if (state.copyText) h += '<textarea class="hfb-copybox" data-hfb-copybox readonly aria-label="Parts list">' + esc(state.copyText) + "</textarea>";
    $sheet.innerHTML = h;
  }
  function renderDock() {
    var rows = buildRows().filter(function (r) { return r.ok; });
    var total = rows.reduce(function (s, r) { return s + r.v.p; }, 0);
    $dock.innerHTML = '<div class="hfb-dock__in"><div class="hfb-dock__sum"><small><span class="hfb-dock__bike">' + esc(bikeLabel()) + " · </span>" + rows.length + " " + (rows.length === 1 ? "part" : "parts") + '</small><b class="num">' + money(total) + "</b></div>"
      + '<button class="hfb-btn hfb-dock__sheet" type="button" data-action="tosheet">Your build</button>'
      + '<button class="hfb-btn hfb-btn--gold" type="button" data-action="cart"' + (rows.length && !state.busy ? "" : " disabled") + ">" + (state.busy ? "Adding…" : "Add to cart") + "</button></div>";
    document.documentElement.style.setProperty("--hfb-dock-h", $dock.offsetHeight + "px");
  }
  function renderCount() {
    if (!state.ready) { $count.textContent = "Loading parts…"; return; }
    var n = all().filter(fits).length;
    $count.innerHTML = "<b>" + n + " parts</b> fit your " + esc(bikeLabel());
  }
  function render() {
    renderPhoto(); renderStage(); renderZones(); renderPicker(); renderSheet(); renderDock(); renderCount();
    if (state.ready) save();
    state.flash = null;
  }

  /* ---------- actions ---------- */
  function toast(msg) {
    $toast.textContent = msg; $toast.hidden = false;
    clearTimeout(toast.h); toast.h = setTimeout(function () { $toast.hidden = true; }, 2200);
  }
  function copyList() {
    var rows = buildRows().filter(function (r) { return r.ok; });
    var total = rows.reduce(function (s, r) { return s + r.v.p; }, 0);
    var lines = ["Henne build: " + bikeLabel(), ""];
    rows.forEach(function (r) {
      lines.push(r.z.name + ": " + r.p.t + (variantText(r.p, r.v) ? " (" + variantText(r.p, r.v) + ")" : "") + " - " + money(r.v.p));
      lines.push("  " + location.origin + productUrl(r.p, r.v));
    });
    lines.push("", "Parts total: " + money(total));
    var text = lines.join("\n");
    function fallback() {
      state.copyText = text; renderSheet();
      var cb = $sheet.querySelector("[data-hfb-copybox]"); if (cb) { cb.focus(); cb.select(); }
    }
    try {
      navigator.clipboard.writeText(text).then(function () { state.copyText = null; toast("Parts list copied"); }, fallback);
    } catch (e) { fallback(); }
  }
  function cartItem(r) { var it = { id: r.v.id, quantity: 1 }; if (r.p.sp) it.selling_plan = r.p.sp; return it; }
  function postAdd(items) {
    return fetch(shopRoot + "cart/add.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function showCart() {
    var drawer = document.querySelector("m-cart-drawer");
    if (drawer && window.MinimogSettings && window.MinimogSettings.enable_cart_drawer && typeof drawer.onCartDrawerUpdate === "function") {
      drawer.onCartDrawerUpdate();
      setTimeout(function () { drawer.open(); }, 400);
    } else {
      window.location.href = shopRoot + "cart";
    }
  }
  function addBuildToCart() {
    var rows = buildRows().filter(function (r) { return r.ok; });
    if (!rows.length || state.busy) return;
    state.busy = true; state.msg = null; renderSheet(); renderDock();
    var failed = [];
    postAdd(rows.map(cartItem)).catch(function () {
      // one part failed (sold out, limit): add them one by one and report the ones that didn't go in
      return rows.reduce(function (pr, r) {
        return pr.then(function () { return postAdd([cartItem(r)]).catch(function () { failed.push(r.p.t); }); });
      }, Promise.resolve());
    }).then(function () {
      state.busy = false;
      if (failed.length) state.msg = "These parts couldn't be added: " + failed.join("; ") + ". Open the product page to check the options.";
      render();
      if (failed.length < rows.length) { toast("Build added to cart"); showCart(); }
    });
  }
  function goZone(id) {
    var changed = state.zone !== id;
    state.zone = id; state.q = "";
    render();
    if (changed) {
      var c = $picker.querySelector(".hfb-card.is-sel");
      $picker.scrollTop = c ? Math.max(0, c.getBoundingClientRect().top - $picker.getBoundingClientRect().top - 150) : 0;
    }
    if (window.matchMedia("(max-width: 1080px)").matches) $picker.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  function showNeed(k) {
    var r = RULES[+k];
    var p = all().filter(fits).filter(function (q) { return r.need.test(q.t); })[0];
    if (!p) { toast("We don't carry that part for your bike"); return; }
    state.zone = p.z; state.q = ""; state.flash = p.i;
    render();
    var c = document.getElementById("hbb-card-" + p.i);
    if (c) c.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  function loadExample() {
    state.sel = {};
    var avail = all().filter(fits);
    (PROF.example || []).forEach(function (alts) {
      for (var i = 0; i < alts.length; i++) {
        var p = avail.filter(function (q) { return alts[i].test(q.t); })[0];
        if (p) { add(p); return; }
      }
    });
    state.zone = ZONES[0].id;
  }

  root.addEventListener("click", function (e) {
    var el = e.target.closest("[data-action]");
    if (!el || el.disabled || !BIKES.length) return;
    var a = el.getAttribute("data-action");
    if (a === "zone") goZone(el.getAttribute("data-z"));
    else if (a === "toggle") {
      if (!state.ready) return;
      var p = PRODUCTS[el.getAttribute("data-p")];
      if (state.sel[p.i] != null) remove(p); else add(p);
      state.copyText = null; state.msg = null;
      render();
      var c = document.getElementById("hbb-card-" + p.i); if (c) c.querySelector(".hfb-card__main").focus({ preventScroll: true });
    }
    else if (a === "remove") { remove(PRODUCTS[el.getAttribute("data-p")]); state.copyText = null; render(); }
    else if (a === "need") showNeed(el.getAttribute("data-k"));
    else if (a === "copy") copyList();
    else if (a === "cart") addBuildToCart();
    else if (a === "dropbad") { selected().forEach(function (p) { if (!fits(p)) remove(p); }); render(); }
    else if (a === "tosheet") $sheet.scrollIntoView({ behavior: "smooth", block: "start" });
    else if (a === "example") { if (!state.ready) return; loadExample(); state.copyText = null; render(); toast("Example build loaded"); }
    else if (a === "clear") { state.sel = {}; state.copyText = null; state.msg = null; render(); toast("Back to stock"); }
  });
  root.addEventListener("change", function (e) {
    var el = e.target.closest('[data-action="opt"]');
    if (!el) return;
    var p = PRODUCTS[el.getAttribute("data-p")], k = +el.getAttribute("data-k"), cur = variantOf(p);
    var best = okVariants(p).filter(function (v) { return v.o[k] === el.value; }).sort(function (a, b) { return sameOpts(b, cur, k) - sameOpts(a, cur, k); })[0];
    if (best) state.sel[p.i] = best.id;
    render();
    var again = $picker.querySelector('[data-action="opt"][data-p="' + p.i + '"][data-k="' + k + '"]');
    if (again) again.focus({ preventScroll: true });
  });
  root.addEventListener("input", function (e) {
    if (!e.target.hasAttribute("data-hfb-q")) return;
    state.q = e.target.value;
    renderPicker();
  });

  /* ---------- start ---------- */
  document.body.classList.add("hfb-has-dock");
  loadBikes().then(function () {
    if (!BIKES.length) { $picker.innerHTML = '<p class="hfb-empty">No bikes are set up for this builder yet.</p>'; $count.textContent = ""; return; }
    var saved = readJSON(STORE_KEY), garage = readJSON(GARAGE_KEY);
    function known(h) { return BIKES.some(function (b) { return b.h === h; }); }
    state.bike = (saved && known(saved.bike) && saved.bike) || (garage && known(garage.handle) && garage.handle)
      || (known(DEFAULT_BIKE) && DEFAULT_BIKE) || BIKES[BIKES.length - 1].h;
    if (saved && saved.bike === state.bike && ZONE[saved.zone]) state.zone = saved.zone;
    fillBikeSelects();
    render();
    return loadBike(bike()).then(function () {
      if (saved && saved.sel && saved.bike === state.bike) Object.keys(saved.sel).forEach(function (id) {
        var p = PRODUCTS[id];
        if (p && p.vs.some(function (v) { return v.id === saved.sel[id]; })) state.sel[p.i] = saved.sel[id];
      });
      state.ready = true;
      render();
    });
  }).catch(function () {
    state.ready = true;
    $picker.innerHTML = '<p class="hfb-empty">We couldn\'t load the builder. Please refresh the page.</p>';
  });
})();
